import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { ApiError, AuthService, BaseFilterCollapse, BaseFilterCollapseService, ConfigService, MessageService } from '../../../core';
import { ConfigEmpresa, isTipoMercadoMarca, isTipoMercadoUnidadeNegocio, isTipoMercadoUnidadeNegocioComLinhaProducao } from '../../configuracoes/app/empresa';
import { ConfigItem } from '../../configuracoes/app/item';
import { ItemFamilia, ItemFamiliaCrudHttpService } from '../../item-familia';
import { ItemGrupo } from '../grupo/item-grupo';
import { ItemGrupoCrudHttpService } from '../grupo/item-grupo-crud-http.service';
import { ItemLinha, ItemLinhaCrudHttpService } from '../../item-linha';
import { ItemMarca, ItemMarcaCrudHttpService } from '../../item-marca';
import { ItemSubgrupo } from '../subgrupo/item-subgrupo';
import { ItemSubgrupoCrudHttpService } from '../subgrupo/item-subgrupo-crud-http.service';
import { LinhaProducao, LinhaProducaoCrudHttpService } from '../../linha-producao';
import { Pessoa } from '../../pessoa';
import { Representante } from '../../pessoa/representante';
import { itemSituacoes } from '../item-situacao';
import { ItemFilterSearch } from './item-filter-search';

@Component({
    selector: 'sgt-item-filter-collapse',
    templateUrl: './item-filter-collapse.component.html',
    styleUrls: ['./item-filter-collapse.component.less']
})
export class ItemFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    configEmpresa: ConfigEmpresa;
    configItem: ConfigItem;

    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;


    @Input() filter: ItemFilterSearch;
    @Output() filterInitialized = new EventEmitter<any>();
    situacoes = itemSituacoes;
    grupos: ItemGrupo[] = [];
    subgrupos: ItemSubgrupo[] = [];
    familias: ItemFamilia[] = [];
    linhas: ItemLinha[] = [];
    marcas: ItemMarca[];
    linhasProducao: LinhaProducao[] = [];
    isRepresentante: boolean;

    isFirstChangeClassificacoesMultiselect = true;

    constructor(private authService: AuthService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private configService: ConfigService,
                private messageService: MessageService,
                private itemGrupoCrudHttpService: ItemGrupoCrudHttpService,
                private itemSubgrupoCrudHttpService: ItemSubgrupoCrudHttpService,
                private itemFamiliaCrudHttpService: ItemFamiliaCrudHttpService,
                private itemLinhaCrudHttpService: ItemLinhaCrudHttpService,
                private itemMarcaCrudHttpService: ItemMarcaCrudHttpService,
                private linhaProducaoCrudHttpService: LinhaProducaoCrudHttpService,
                private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.configItem = this.configService.getItem();

        this.isRepresentante = this.authService.isRepresentante();

        this.initFilter();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
      if (!this.isCollapsedInDefault) {
        jQuery(this.filterCollapse.nativeElement).css('display', 'none');
      }
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.searchMarcas();
        this.searchLinhas();
        this.searchFamilias();
        this.searchGrupos();
        this.searchSubgrupos();
        this.searchLinhasProducao();

        this.filterInitialized.emit();
    }

    /** Verifica se o Tipo de Mercado da empresa é por Marca */
    isTipoMercadoMarca(): boolean {
        if (!this.configEmpresa) {
            return false;
        }
        return isTipoMercadoMarca(this.configEmpresa.tipoMercado);
    }

    /** Verifica se o Tipo de Mercado da empresa é por Unidade de Negócio */
    isTipoMercadoUnidadeNegocio(): boolean {
        if (!this.configEmpresa) {
            return false;
        }
        return isTipoMercadoUnidadeNegocio(this.configEmpresa.tipoMercado);
    }

    /** Verifica se o Tipo de Mercado da empresa é por Unidade de Negócio e com Linha de Produção */
    isTipoMercadoUnidadeNegocioComLinhaProducao(): boolean {
        if (!this.configEmpresa) {
            return false;
        }
        return isTipoMercadoUnidadeNegocioComLinhaProducao(this.configEmpresa.tipoMercado, this.configEmpresa.tipoMercadoUnidadeNegocioComLinhaProducao);
    }

    /** Pesquisa as marcas cadastradas */
    private searchMarcas() {
        this.itemMarcaCrudHttpService.search()
            .subscribe(
                entities => this.marcas = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as marcas dos itens', error)
            );
    }

    /** Pesquisa os itens linhas cadastrados */
    private searchLinhas() {
        this.itemLinhaCrudHttpService.search()
            .subscribe(
                entities => this.linhas = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as linhas dos itens', error)
            );
    }

    /** Pesquisa os itens familias cadastrados */
    private searchFamilias() {
        this.itemFamiliaCrudHttpService.search()
            .subscribe(
                entities => this.familias = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as famílias dos itens', error)
            );
    }

    /** Pesquisa os itens grupos cadastrados */
    private searchGrupos() {
        this.itemGrupoCrudHttpService.search()
            .subscribe(
                entities => this.grupos = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os grupos dos itens', error)
            );
    }

    /** Pesquisa os itens subgrupos cadastrados */
    private searchSubgrupos() {
        this.itemSubgrupoCrudHttpService.search()
            .subscribe(
                entities => this.subgrupos = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os subgrupos dos itens', error)
            );
    }

    /** Pesquisa as linhas de produção cadastradas */
    private searchLinhasProducao() {
        this.linhaProducaoCrudHttpService.search()
            .subscribe(
                entities => this.linhasProducao = entities,
                (error: ApiError) => this.messageService.error(error.message,  'Erro aos pesquisar as Linhas de Produção', error)
            );
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
    }

    /** Ao alterar o cliente/pessoa no typeahead */
    onChangeCliente(pessoa: Pessoa) {
        if (pessoa) {
            this.filter.idPessoa = pessoa.id;
            this.isFilterDirty = true;
            this.cdr.detectChanges();
        } else {
            this.filter.idPessoa = null;
        }
    }

    /** Ao alterar o representante no typeahead */
    onChangeRepresentante(representante: Representante) {
        if (representante) {
            this.filter.idRepresentante = representante.id;
            this.isFilterDirty = true;
            this.cdr.detectChanges();
        } else {
            this.filter.idRepresentante = null;
        }
    }

    /** Ao alterar as classificações */
    onChangeClassificacoes() {
        if (this.isFirstChangeClassificacoesMultiselect) {
            this.isFirstChangeClassificacoesMultiselect = false;
            return;
        }
    }

    /** Ao alterara as unidades de negócios */
    onChangeUnidadesNegocios() {
        this.isFilterDirty = true;
        this.cdr.detectChanges();
    }

    /** Ao alterar os tipos de itens */
    onChangeItensTipos() {
        this.isFilterDirty = true;
        this.cdr.detectChanges();
    }

    /** Ao alterar as naturezas de vendas */
    onChangeNaturezasVendas() {
        this.isFilterDirty = true;
        this.cdr.detectChanges();
    }

    /** Ao alterar os mercados */
    onChangeMercados() {
        this.isFilterDirty = true;
        this.cdr.detectChanges();
    }
}
